import React, { useState, useEffect } from "react";

export default function MemberLoginHistoryFilter({ onFilter, initialProfileId = "" }) {
    const [filters, setFilters] = useState({
        from_date: "",
        to_date: "",
        profile_id: initialProfileId,
        device_type: "",
        login_status: "",
        search: "",
    });

    // Update filters when initialProfileId changes
    useEffect(() => {
        setFilters((prev) => ({
            ...prev,
            profile_id: initialProfileId,
        }));
    }, [initialProfileId]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (onFilter) {
            onFilter(filters);
        }
    };

    const handleReset = () => {
        const emptyFilters = {
            from_date: "",
            to_date: "",
            profile_id: "",
            device_type: "",
            login_status: "",
            search: "",
        };
        setFilters(emptyFilters);
        if (onFilter) {
            onFilter(emptyFilters);
        }
    };

    return (
        <div className="filtercont" style={{ marginBottom: "20px" }}>
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="row">
                            {/* From Date */}
                            <div className="col-12 col-sm-2 pr-lg-0">
                                <label>From Date</label>
                                <input
                                    type="date"
                                    name="from_date"
                                    value={filters.from_date}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                            </div>

                            {/* To Date */}
                            <div className="col-12 col-sm-2 pr-lg-0">
                                <label>To Date</label>
                                <input
                                    type="date"
                                    name="to_date"
                                    value={filters.to_date}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                            </div>

                            {/* Profile ID */}
                            <div className="col-12 col-sm-2 pr-lg-0">
                                <label>Profile ID</label>
                                <input
                                    type="text"
                                    name="profile_id"
                                    placeholder="Enter Profile ID"
                                    value={filters.profile_id}
                                    onChange={handleChange}
                                    readOnly={!!initialProfileId}
                                    className="form-control"
                                    style={{ backgroundColor: initialProfileId ? "#f5f5f5" : "white" }}
                                />
                            </div>

                            {/* Device Type */}
                            <div className="col-12 col-sm-2 pr-lg-0">
                                <label>Device Type</label>
                                <select
                                    name="device_type"
                                    value={filters.device_type}
                                    onChange={handleChange}
                                    className="form-control"
                                >
                                    <option value="">All</option>
                                    <option value="Mobile">Mobile</option>
                                    <option value="Desktop">Desktop</option>
                                    <option value="Tablet">Tablet</option>
                                    <option value="Unknown">Unknown</option>
                                </select>
                            </div>

                            {/* Login Status */}
                            {/* <div className="col-12 col-sm-2 pr-lg-0">
                <label>Status</label>
                <select
                  name="login_status"
                  value={filters.login_status}
                  onChange={handleChange}
                  className="form-control"
                >
                  <option value="">All</option>
                  <option value="success">Success</option>
                  <option value="failed">Failed</option>
                </select>
              </div> */}

                            {/* Search */}
                            {/* <div className="col-12 col-sm-2 pr-lg-0">
                <label>Search</label>
                <input
                  type="text"
                  name="search"
                  placeholder="IP / Browser / OS"
                  value={filters.search}
                  onChange={handleChange}
                  className="form-control"
                />
              </div> */}


                            {/* Buttons */}
                            <div className="col-12 col-sm-2 pr-lg-0">
                                <label htmlFor=""></label>
                                <button
                                    type="submit"
                                    className="btn btn-default submit sitebtn px-3 text-center"
                                    style={{ marginRight: "10px" }}
                                >
                                    <i className="fa fa-search" /> Search
                                </button>
                            </div>
                            {/* <div className="col-12 col-sm-2 pr-lg-0">
                                <label htmlFor=""></label>
                                <button
                                    type="button"
                                    onClick={handleReset}
                                    className="btn btn-default submit sitebtn px-3 text-center"
                                    style={{ backgroundColor: "#f0f0f0", color: "#333" }}
                                >
                                    <i className="fa fa-refresh" /> Reset
                                </button>
                            </div> */}
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}
